import React, {useContext} from 'react'
import firstGif from './QuestionStep/assets/start.gif'
import firstGifEn from './QuestionStep/assets/start-en.gif'
import firstGifAr from './QuestionStep/assets/start-ar.gif'
import firstJPG from './QuestionStep/assets/static/start.jpg'
import firstJPGEn from './QuestionStep/assets/static/start-en.jpg'
import firstJPGAr from './QuestionStep/assets/static/start-ar.jpg'
import logo from './QuestionStep/assets/logo.svg'
import logoEn from './QuestionStep/assets/logo-en.svg'
import logoAr from './QuestionStep/assets/logo-ar.svg'

export function getStartGif () {
    switch (localStorage.getItem('lang')) {
        case 'he':
            return firstGif;
        case 'en':
            return firstGifEn;
        case 'ar':
            return firstGifAr;
    }
}

export function getStartJpg () {
    switch (localStorage.getItem('lang')) {
        case 'he':
            return firstJPG;
        case 'en':
            return firstJPGEn;
        case 'ar':
            return firstJPGAr;
    }
}

export function getLogo () {
    switch (localStorage.getItem('lang')) {
        case 'he':
            return logo;
        case 'en':
            return logoEn;
        case 'ar':
            return logoAr;
    }
}
